import "../STPremiumPage/PureComponents/STPremiumPage.css";

import React, { useEffect, useState } from "react";
import {
  getAllInternalTickets,
  getCategoryData,
  getInternalTicketList,
  getLocationData,
  getPersonalizedTicketList,
  getRequestorList,
} from "Config/API/get";
import {
  notConnectedAmniusAction,
  raiseRequestDataAction,
  selectedOrganizationSTAction,
} from "Redux/action/variable.action";
import { useDispatch, useSelector } from "react-redux";

import AccessTimeIcon from "@mui/icons-material/AccessTime";
import Headers from "Components/Header/Headers";
import Navigation from "Components/SideNavBar/Navigation";
import SearchIcon from "@mui/icons-material/Search";
import SeverityLabel from "../Common/SeverityLabel";
import moment from "moment-timezone";
import { ticketIdAction } from "Redux/action/variable.action";
import { toast } from "react-toastify";
import useFullPageLoader from "Hooks/useFullPageLoader";
import { useNavigate } from "react-router-dom";
import RenderRequestTypePopup from "Components/Popup/RequestTypePopup/Container/RenderRequestTypePopup";
import RenderTicketTypePopup from "Components/Popup/RenderTicketTypePopup";
import RenderConfirmoption from "Components/Popup/Option/Container/RenderConfirm";

const DONE_TYPING_INTERVAL = 1500;

const ALL_TICKETS_HEADERS = [
  { label: "TICKET #", style: { width: "30%" } },
  { label: "REQUESTOR" },
  { label: "ASSIGNED TECH" },
  { label: "LOCATION" },
  { label: "TEAM" },
  { label: "SEVERITY" },
  { label: "DATE OPENED" },
];
const MY_TICKETS_HEADERS = [
  { label: "TICKET #", style: { width: "25%" } },
  { label: "REQUESTOR" },
  { label: "SEVERITY" },
  { label: "DATE OPENED" },
];

const SEVERITY_FILTER_OPTIONS = [
  { value: "all", label: "All" },
  { value: "urgent", label: "Urgent" },
  { value: "moderate", label: "Moderate" },
  { value: "low", label: "Low" },
  { value: "pause", label: "Paused" },
  { value: "closed", label: "Closed" },
];
// The "My Active Service Tickets" filter labels the paused option "Pause"
const MY_SEVERITY_FILTER_OPTIONS = SEVERITY_FILTER_OPTIONS.map((option) =>
  option.value === "pause" ? { ...option, label: "Pause" } : option
);

const AllInternalTickets = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let typingTimer;
  const pageType = useSelector((state) => state.servicePageTypeReducer);
  const loggedInUser = useSelector((state) => state.authenticationReducer);
  const token = localStorage.getItem("token");
  const [loader, setLoader, resetLoader] = useFullPageLoader();
  const [ticketList, setTicketList] = useState([]);
  const [filterValue, setFilterValue] = useState("all");
  const [personalizedTicketList, setPersonalizedTicketList] = useState("");
  const [personalizedFilterKeyword, setPersonalizedFilterKeyword] =
    useState("");
  const [searchKeyWords, setSearchKeywords] = useState("");
  const [location_list, setLocation_list] = useState([]);
  const [locationName, setLocationName] = useState("");
  const [categoryName, setCategoryName] = useState("");
  const [teams, setTeams] = useState([]);
  const [filterKeyword] = useState("");
  const [confirmPopup, setConfirmPopup] = useState(false);
  const [generalticket, setGeneralticket] = useState(false);
  const [requestOption, setRequestOption] = useState("");
  const [ticketOption, setTicketOption] = useState("");
  const [requestTypeconfirmPopup, setRequestTypeConfirmPopup] = useState(false);

  const isPremiumPage = pageType?.toString() === "PREMIUM";
  const canCreateTicket =
    loggedInUser?.ticket_internal_role === "manager" ||
    loggedInUser?.ticket_external_role === "manager";
  const canViewTicketTabs =
    loggedInUser?.ticket_external_read_role === "manager" ||
    loggedInUser?.ticket_internal_read_role === "manager";

  useEffect(() => {
    getAllLocations();
    personalized_filter_function("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getAllInternalServiceTickets(
      filterValue,
      searchKeyWords,
      locationName,
      categoryName
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterValue, searchKeyWords]);

  useEffect(() => {
    getCategoryData(token, loggedInUser?.org_id, locationName).then((res) => {
      setTeams(res?.category);
    });
  }, [locationName]);

  const getAllLocations = () => {
    getLocationData(token, loggedInUser?.org_id).then((res) => {
      if (res?.location?.length > 0) {
        setLocation_list(res?.location);
      }
    });
  };

  const getAllInternalServiceTickets = (
    filter,
    searchKeyword,
    location,
    categoryId
  ) => {
    setLoader();
    getAllInternalTickets(
      token,
      filter,
      searchKeyword,
      location,
      categoryId
    ).then((res) => {
      resetLoader();
      if (res?.data?.status) {
        if (filter !== "closed") {
          return setTicketList(
            res?.data?.ticket?.filter((item) => item?.severity_issue !== "closed")
          );
        }
        setTicketList(res?.data?.ticket);
      } else toast(res?.data?.message, { type: "error" });
    });
  };

  const personalized_filter_function = (value) => {
    setLoader();
    getPersonalizedTicketList(token, value, "", "internal").then((res) => {
      resetLoader();
      if (res?.status) {
        if (value !== "closed") {
          return setPersonalizedTicketList(
            res?.ticket?.filter((item) => item?.severity_issue !== "closed")
          );
        }
        setPersonalizedTicketList(res?.ticket);
      } else toast(res?.message, { type: "error" });
    });
  };

  const search_fuction = (value) => {
    if (isPremiumPage) {
      getInternalTicketList(token, filterKeyword, value, "", "").then((res) => {
        if (res?.status) {
          setTicketList(res?.ticket);
        } else toast(res?.message, { type: "error" });
      });

      getPersonalizedTicketList(
        token,
        personalizedFilterKeyword,
        value,
        "internal"
      ).then((res) => {
        if (res?.status) {
          setPersonalizedTicketList(res?.ticket);
        }
      });
    } else {
      getRequestorList(token, filterKeyword, value).then((res) => {
        if (res?.status) {
          setTicketList(res?.ticket);
        }
      });
    }
  };

  // creating tickets: first the request type, then the ticket type
  const handleRequestType = (option) => {
    setGeneralticket(true);
    setRequestOption(option);
    setRequestTypeConfirmPopup(false);
  };

  const handleTicketType = (selectedTicketOption) => {
    const isInternalRequest = requestOption === "Internal";

    if (selectedTicketOption === "General") {
      if (isInternalRequest) {
        navigate("/create-general-internal-service-ticket");
      } else {
        setConfirmPopup(true);
      }
    } else if (selectedTicketOption === "Asset") {
      if (isInternalRequest) {
        navigate("/create-internal-service-ticket", { state: "new ticket" });
      } else {
        setConfirmPopup(true);
      }
    }
    setTicketOption(selectedTicketOption);
    setGeneralticket(false);
  };

  // connected or not function
  const connectedFunction = (option) => {
    const createPage =
      ticketOption === "Asset"
        ? "/service-ticket-create"
        : "/service-ticket-create-general";

    dispatch(notConnectedAmniusAction(option?.toString() !== "Yes"));
    navigate(createPage, { state: "new ticket" });
    dispatch(selectedOrganizationSTAction(""));
    dispatch(raiseRequestDataAction(""));
  };

  const renderHeaderRow = (headers, extraClassName = "") => (
    <div className={`stpmain-row-wrapper${extraClassName}`}>
      {headers.map(({ label, style }) => (
        <div key={label} className="stpmain-head-row" style={style}>
          {label}
        </div>
      ))}
    </div>
  );

  const renderSeverityOptions = (options) =>
    options.map(({ value, label }) => (
      <option key={value} value={value}>
        {label}
      </option>
    ));

  return (
    <>
      <div className="stpmain-parent">
        <div className="stpmain-header">
          <Headers />
        </div>

        <div className="stpmain-navigation">
          <Navigation />
        </div>

        <div className="stpmain-main">
          <div className="stpmain-ticket-search">
            <input
              type="search"
              placeholder={
                isPremiumPage
                  ? "Search tickets by ticket # or requestor name"
                  : "Search tickets by ticket # or provider name"
              }
              onChange={(e) => {
                typingTimer = setTimeout(() => {
                  search_fuction(e.target.value);
                  setSearchKeywords(e.target.value);
                }, DONE_TYPING_INTERVAL);
              }}
            />
            <SearchIcon />
          </div>
          {isPremiumPage && canViewTicketTabs ? (
            <div className="stpmain-options-btn">
              <button
                className="stpmain-outline-btn"
                onClick={() => navigate("/service-ticket-view-page")}
              >
                EXTERNAL TICKETS
              </button>
              <button
                disabled={!canCreateTicket}
                className={canCreateTicket ? "create-ticket" : "external-rights"}
                onClick={() => setRequestTypeConfirmPopup(true)}
              >
                Create New Ticket
              </button>
              <button
                className="stpmain-outline-btn-active"
                onClick={() => navigate("/all-internal-service-tickets")}
              >
                INTERNAL TICKETS
              </button>
            </div>
          ) : null}
          <div className="stpmain-wrapper">
            <div className="stpmain-all-active" id="ticket-body">
              <div className="stpmain-top ">
                <p className="sttop-heading">All Active Service Tickets</p>
                <div>
                  <p>Location:</p>
                  <select
                    onChange={(e) => {
                      getAllInternalServiceTickets("", "", e.target.value, "");
                      setLocationName(e.target.value);
                    }}
                  >
                    <option value="all">All</option>
                    {location_list?.map((item) => (
                      <option
                        key={item?.key}
                        label={item?.location}
                        value={item?.id}
                      >
                        {item?.location}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <p>Team:</p>
                  <select
                    onChange={(e) => {
                      getAllInternalServiceTickets(
                        "",
                        "",
                        locationName,
                        e.target.value
                      );
                      setCategoryName(e.target.value);
                    }}
                    disabled={locationName === ""}
                  >
                    <option value="all">All</option>
                    {teams?.map((item) => (
                      <option key={item?.key} value={item?.id}>
                        {item?.category_id}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <p>Filter:</p>
                  <select onChange={(e) => setFilterValue(e.target.value)}>
                    {renderSeverityOptions(SEVERITY_FILTER_OPTIONS)}
                  </select>
                </div>
              </div>
              {renderHeaderRow(ALL_TICKETS_HEADERS)}
              <div className="stpmain-bottom">
                {ticketList?.length > 0 ? (
                  ticketList?.map((item, index) => (
                    <div className="stpmain-content-wrapper" key={index}>
                      <div
                        className="stpmain-content-row"
                        style={{ width: "30%" }}
                        onClick={() => {
                          dispatch(ticketIdAction(item?.ticket_id));
                          navigate("/service-ticket-details");
                        }}
                      >
                        {item?.ticket_id}
                      </div>
                      <div className="stpmain-content-row">
                        {item?.requestor_name}
                      </div>
                      <div className="stpmain-content-row">
                        {item?.assign_tech || "Not Assigned"}
                      </div>
                      <div className="stpmain-content-row">
                        {item?.locationName}
                      </div>
                      <div className="stpmain-content-row">
                        {item?.categoryName}
                      </div>
                      <div className="stpmain-content-row">
                        <SeverityLabel
                          severity={item?.severity_issue}
                          pauseLabel="Paused"
                        />
                      </div>
                      <div
                        className="stpmain-content-row stpmain-date-row"
                        style={{ position: "relative" }}
                      >
                        {moment(item?.createdAt).format("MM/DD/YYYY")}
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="stpmain-msg">No Tickets Found</div>
                )}
              </div>
            </div>
            {isPremiumPage ? (
              <div className="stpmain-my-active">
                <div className="stpmain-top ">
                  <p className="sttop-heading">My Active Service Tickets</p>
                  <div>
                    <p>Filter:</p>
                    <select
                      onChange={(e) => {
                        personalized_filter_function(e.target.value);
                        setPersonalizedFilterKeyword(e.target.value);
                      }}
                    >
                      {renderSeverityOptions(MY_SEVERITY_FILTER_OPTIONS)}
                    </select>
                  </div>
                </div>
                {renderHeaderRow(MY_TICKETS_HEADERS, " stpmain-right-side")}
                <div className="stpmain-bottom stpmain-right-side">
                  {personalizedTicketList?.length?.toString() !== "0" ? (
                    personalizedTicketList?.map((curr, index) => (
                      <div className="stpmain-content-wrapper" key={index}>
                        <div
                          className="stpmain-content-row"
                          style={{ width: "25%" }}
                          onClick={() => {
                            dispatch(ticketIdAction(curr?.ticket_id));
                            navigate("/service-ticket-details");
                          }}
                        >
                          {curr?.ticket_id}
                        </div>
                        <div className="stpmain-content-row">
                          {curr?.requestor}
                        </div>
                        <div className="stpmain-content-row">
                          <SeverityLabel
                            severity={curr?.severity_issue}
                            pauseLabel="Pause"
                          />
                        </div>
                        <div
                          className="stpmain-content-row stpmain-date-row"
                          style={{ position: "relative" }}
                        >
                          {curr?.create_at}

                          {curr?.scheduled_status?.toString() !== "no" ? (
                            <AccessTimeIcon
                              style={{
                                color:
                                  curr?.scheduled_status?.toString() === "green"
                                    ? "#5ca127"
                                    : "#d81c1c",
                              }}
                            />
                          ) : null}
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="stpmain-msg">No Tickets Found</div>
                  )}
                </div>
              </div>
            ) : null}
          </div>
          {requestTypeconfirmPopup ? (
            <RenderRequestTypePopup
              message={"Please Select Request Type"}
              option1={"External"}
              option2={"Internal"}
              funct={handleRequestType}
              hide={setRequestTypeConfirmPopup}
            />
          ) : null}
          {generalticket ? (
            <RenderTicketTypePopup
              message={"Please Select Ticket Type"}
              option1={"General"}
              option2={"Asset"}
              funct={handleTicketType}
              hide={setGeneralticket}
            />
          ) : null}
          {confirmPopup ? (
            <RenderConfirmoption
              message={"Is Requestor A Connected Amnius User?"}
              option1={"Yes"}
              option2={"No"}
              funct={connectedFunction}
              hide={setConfirmPopup}
            />
          ) : null}
          {loader}
        </div>
      </div>
    </>
  );
};

export default AllInternalTickets;
